// programa-solidaridad.js
import router from "@/router";
import Swal from 'sweetalert2/dist/sweetalert2';

export default {
    state: {
        // PROGRAMA SOLIDARIDAD
        getProgramaSolidaridad: false
    },
    mutations: {
        GET_PROGRAMA_LIBERTAD(state, status) {
            state.getProgramaSolidaridad = status
        },

    },
    actions: {
    },
    getters: {
        getProgramaSolidaridad: state => state.getProgramaSolidaridad,
    }
};

